module.exports = require("ajv-draft-04");